import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';

import { LanguageService } from '../../../core/services/language.service';
import { environment } from '../../../../environments/environment';
import { LoginService } from 'src/app/core/services/login.service';
import { AuthorizedUser } from 'src/app/core/models/auth.models';
import { NotificationService } from 'src/app/core/services/notification.service';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent implements OnInit {

  element: any;
  configData: any;
  cookieValue;
  flagvalue;
  countryName;
  valueset: string;
  isMobile = false;

  currentUser?: AuthorizedUser;

  get welcomeName(): string {
    const firstName = (this.currentUser?.firstName || '').trim();
    const displayName = (this.currentUser?.displayName || '').trim();
    return firstName || displayName || 'User';
  }

  listLang = [
    { text: 'English', flag: 'assets/images/flags/us.jpg', lang: 'en' },
    { text: 'Spanish', flag: 'assets/images/flags/spain.jpg', lang: 'es' },
    { text: 'German', flag: 'assets/images/flags/germany.jpg', lang: 'de' },
    { text: 'Italian', flag: 'assets/images/flags/italy.jpg', lang: 'it' },
    { text: 'Russian', flag: 'assets/images/flags/russia.jpg', lang: 'ru' },
  ];

  // tslint:disable-next-line: max-line-length
  constructor(
    @Inject(DOCUMENT) private document: any, private router: Router, 
    private loginService: LoginService,
    public languageService: LanguageService, public cookiesService: CookieService, private notificationService: NotificationService) { }

  @Output() mobileMenuButtonClicked = new EventEmitter();
  @Output() settingsButtonClicked = new EventEmitter();
async ngOnInit(): Promise<void> {
  this.isMobile = window.innerWidth <= 768;

  if (!this.isMobile) {
    this.setupMouseDetection();
    this.isHidden = true; // start hidden on desktop
  } else {
    this.isHidden = false; // always visible on mobile
  }

  this.currentUser = this.loginService.user;
  this.element = document.documentElement;

  this.configData = {
    suppressScrollX: true,
    wheelSpeed: 0.3
  };

  this.cookieValue = this.cookiesService.get('lang');
  const val = this.listLang.filter(x => x.lang === this.cookieValue);

  this.countryName = val.map(element => element.text);
  if (val.length === 0) {
    if (this.flagvalue === undefined) {
      this.valueset = 'assets/images/flags/us.jpg';
    }
  } else {
    this.flagvalue = val.map(element => element.flag);
  }
}


  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  /**
   * Toggles the right sidebar
   */
  toggleRightSidebar() {
    this.settingsButtonClicked.emit();
  }

  /**
   * Fullscreen method
   */
  fullscreen() {
    document.body.classList.toggle('fullscreen-enable');
    if (
      !document.fullscreenElement && !this.element.mozFullScreenElement &&
      !this.element.webkitFullscreenElement) {
      if (this.element.requestFullscreen) {
        this.element.requestFullscreen();
      } else if (this.element.mozRequestFullScreen) {
        /* Firefox */
        this.element.mozRequestFullScreen();
      } else if (this.element.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.element.webkitRequestFullscreen();
      } else if (this.element.msRequestFullscreen) {
        /* IE/Edge */
        this.element.msRequestFullscreen();
      }
    } else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }
  }

  /**
   * Translate language
   */
  setLanguage(text: string, lang: string, flag: string) {
    this.countryName = text;
    this.flagvalue = flag;
    this.cookieValue = lang;
    this.languageService.setLanguage(lang);
  }


  /**
   * Logout the user
   */
  logout() {
    this.loginService.logout();
    this.router.navigate(['/account/login']);
  }

  checkPushSubscription() {
    navigator.serviceWorker.ready
      .then(reg => reg.pushManager.getSubscription())
      .then(sub => {
        console.log('📦 Push subscription on device:', sub);
        alert(sub ? '✅ Subscribed to push!' : '🚫 Not subscribed to push notifications.');
      })
      .catch(err => {
        console.error('Failed to check push subscription:', err);
        alert('❌ Error checking subscription.');
      });
  }
  
  triggerPush() {
    alert('🔔 Button clicked'); // test if click is even working
    this.notificationService.requestPushSubscription();
  }

  public showNotificationBell(): boolean {
    return this.currentUser?.userType === 'ROOT' || this.currentUser?.userType === 'INTERNAL';
  }

  isHidden = true;
hideTimeout: any;


setupMouseDetection() {
  document.addEventListener('mousemove', this.handleMouseMove.bind(this));
}

handleMouseMove(event: MouseEvent) {
  if (event.clientY < 5) {
    this.isHidden = false;
    clearTimeout(this.hideTimeout);
  }
}

showTopbar() {
  if (this.isMobile) return; // ✅ prevent hiding/showing on mobile
  this.isHidden = false;
  clearTimeout(this.hideTimeout);
}

scheduleHideTopbar() {
  if (this.isMobile) return; // ✅ prevent hiding/showing on mobile
  this.hideTimeout = setTimeout(() => {
    this.isHidden = true;
  }, 1500);
}


  
  
}
